import { SuperDrawerContent, SuperDrawerHeader, TabsWithContent, useSessionStorage } from "@homebound/beam";
import { useBidItemSuperDrawerDetailsQuery } from "src/routes/libraries/item-catalog/components/BidItemSuperDrawer.generated";
import { queryResult } from "src/utils";
import { BidItemCostHistoryTab } from "./tabs/BidItemCostHistoryTab";
import { BidItemOverviewTab } from "./tabs/BidItemOverviewTab";

export type SelectionsSuperDrawerProps = { bidItemId: string };

export function BidItemSuperDrawer({ bidItemId }: SelectionsSuperDrawerProps) {
  const [selectedTab, setSelectedTab] = useSessionStorage("bidItemSuperDrawerTab", "overview");
  const bidItemDetailQuery = useBidItemSuperDrawerDetailsQuery({ variables: { bidItemId } });

  return queryResult(bidItemDetailQuery, ({ bidItems: [bidItem], ...otherOptions }) => {
    const overviewTab = {
      name: "Overview",
      value: "overview",
      render: () => <BidItemOverviewTab bidItem={bidItem} {...otherOptions} />,
    };

    const historyTab = {
      name: "Cost history",
      value: "history",
      render: () => <BidItemCostHistoryTab bidItem={bidItem} />,
    };

    return (
      <SuperDrawerContent>
        <SuperDrawerHeader title={bidItem.name} />
        <TabsWithContent tabs={[overviewTab, historyTab]} selected={selectedTab} onChange={setSelectedTab} />
      </SuperDrawerContent>
    );
  });
}
